import { render, staticRenderFns } from "./FichaProducto.vue?vue&type=template&id=34fb7ed6&scoped=true&"
import script from "./FichaProducto.vue?vue&type=script&lang=ts&"
export * from "./FichaProducto.vue?vue&type=script&lang=ts&"
import style0 from "./FichaProducto.vue?vue&type=style&index=0&id=34fb7ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fb7ed6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
